import { render } from "./Sidebar.vue?vue&type=template&id=8c444514&scoped=true"
const script = {}

import "./Sidebar.vue?vue&type=style&index=0&id=8c444514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c444514"]])

export default __exports__